<template>
  <v-container id="container-wrap">
    <v-row no-gutters>
      <v-spacer></v-spacer>
      <div id="not-found-number">
        404
      </div>
    </v-row>
    <v-row no-gutters>
      <v-spacer></v-spacer>
      <div id="not-found-text">
        Page Not Found
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped>
#container-wrap {
  margin-top: 0%;
  z-index: 1;
}
#not-found-number {
  font-size: 13rem;
  color: white;
}
#not-found-text {
  font-size: 5rem;
  color: white;
}
</style>
